import { render, staticRenderFns } from "./dataSourceDic.vue?vue&type=template&id=3f6ba76c&scoped=true&"
import script from "./dataSourceDic.vue?vue&type=script&lang=js&"
export * from "./dataSourceDic.vue?vue&type=script&lang=js&"
import style0 from "./dataSourceDic.vue?vue&type=style&index=0&id=3f6ba76c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ba76c",
  null
  
)

export default component.exports